import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useLeavePageConfirm = ({
  shouldWarn = true,
  message = "Are you sure you want to leave this page?",
}) => {
  const navigate = useNavigate();

  // 1. Handle browser tab close or refresh
  useEffect(() => {
    if (!shouldWarn) return;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // Required for most browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [shouldWarn]);

  // 2. Handle back/forward browser button navigation
  useEffect(() => {
    if (!shouldWarn) return;

    const handlePopState = (event) => {
      const confirmLeave = window.confirm(message);
      if (!confirmLeave) {
        window.history.pushState(null, "", window.location.href); // Revert navigation
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [shouldWarn, message]);

  // 3. Optional wrapper for in-app navigation
  const confirmNavigate = (to, options = {}) => {
    if (!shouldWarn || window.confirm(message)) {
      navigate(to, options);
    }
  };

  return { confirmNavigate };
};
